<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">问诊费记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="0" class="title">全部</el-menu-item>
            <el-menu-item index="1" class="title">待系统核算</el-menu-item>
            <el-menu-item index="2" class="title">待结算</el-menu-item>
            <el-menu-item index="3" class="title">已结算</el-menu-item>
            <el-menu-item index="4" class="title">已退款</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div>
            <div class="searchbox">
              <div class="item">
                <span>医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_name"
                  style="width: 120px; margin-left: 6px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>手机号</span>
                <el-input
                  placeholder="请输入"
                  v-model="phone"
                  style="width: 120px; margin-left: 6px"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span>交易单号</span>
                <el-input
                  placeholder="请输入"
                  v-model="trade_no"
                  style="width: 120px; margin-left: 6px"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span>问诊结束时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  clearable
                  @change="search"
                  style="width: 230px; margin-left: 6px"
                ></el-date-picker>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-left: 6px;
                  "
                  @click="search"
                  >查询</el-button
                >
              </div>
              <div class="item">
                <span>结束类型</span>
                <el-select
                  v-model="over_type"
                  placeholder="请选择"
                  style="width: 140px; margin-left: 6px"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in status_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span style="margin-right: 10px">是否测试医生</span>
                <el-radio-group v-model="is_test" @change="search">
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="问诊结束时间"
                  prop="over_time"
                ></el-table-column>
                <el-table-column
                  label="问诊费用"
                  prop="consult_fee"
                ></el-table-column>

                <el-table-column label="医生信息" prop="hospital_name">
                  <template slot-scope="scope">
                    <div
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor: pointer"
                    >
                      {{ scope.row.doctor_name }}
                    </div>
                    <div>
                      <span>{{ scope.row.doctor_sex == 1 ? "男" : "女" }}</span>
                      <span style="margin-left: 10px">{{
                        scope.row.title
                      }}</span>
                    </div>
                    <div>{{ scope.row.phone }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="结束类型">
                  <template slot-scope="scope">
                    <!-- <span v-if="scope.row.status == 8">超时未发起</span>
                    <span v-if="scope.row.status == 4">医生拒绝</span>
                    <span v-if="scope.row.status == 6">超时未接诊</span>
                    <span v-if="scope.row.status == 5">问诊时间结束</span>
                    <span v-if="scope.row.status == 7">手动结束</span>
                    <span v-if="scope.row.status == 9">医生退款结束</span> -->
                    {{ scope.row.status | statusText }}
                  </template>
                </el-table-column>
                <el-table-column label="结算状态">
                  <template slot-scope="scope">
                    {{ scope.row.settlement_status | settlement_status_text }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="交易单号"
                  prop="trade_no"
                ></el-table-column>
                <el-table-column
                  label="支付金额"
                  prop="pay_money"
                ></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.consult_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('119')
                          : false
                      "
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding: 20px 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import doctor_fee from "../../../api/doctor_fee";
import moment from "moment";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      activeIndex: "0",
      active: "0",
      settlement_status: 0,
      date: [],
      totalNum: 0,
      doctor_name: "",
      phone: "",
      trade_no: "",
      over_type: "",
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      status_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "超时未发起",
          value: 8,
        },
        {
          label: "医生拒绝",
          value: 4,
        },
        {
          label: "超时未接诊",
          value: 6,
        },
        {
          label: "问诊时间结束",
          value: 5,
        },
        {
          label: "手动结束",
          value: 7,
        },
        {
          label: "平台退款",
          value: 10,
        },
        {
          label: "医生退款",
          value: 9,
        },
        {
          label: "未接诊平台退款",
          value: 11,
        },
        {
          label: "患者申请退款",
          value: 12,
        },
      ],
      is_test: 2,
      doc_msg: false,
      doctorId: "",
    };
  },
  filters: {
    statusText(val) {
      switch (val) {
        case 1:
          return "已支付";
        case 2:
          return "待接诊";
        case 3:
          return "已接诊";
        case 4:
          return "拒绝接诊";
        case 5:
          return "问诊时间结束";
        case 6:
          return "超时未接诊";
        case 7:
          return "手动结束";
        case 8:
          return "超时未发起";
        case 9:
          return "医生退款";
        case 10:
          return "平台退款";
        case 11:
          return "未接诊平台退款";
        case 12:
          return "患者申请退款";
      }
    },
    settlement_status_text(val) {
      switch (val) {
        case 1:
          return "待系统核算";
        case 2:
          return "待结算";
        case 3:
          return "已结算";
        case 4:
          return "已退款";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
  },
  methods: {
    handleSelect(key) {
      this.active = Number(key);
      this.settlement_status = this.active;
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        settlement_status: this.settlement_status,
        doctor_name: this.doctor_name,
        phone: this.phone,
        trade_no: this.trade_no,
        over_type: this.over_type,
        start_time: "",
        end_time: "",
        is_test: this.is_test,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = moment(this.date[0]).format("YYYY-MM-DD");
        data.end_time = moment(this.date[1]).format("YYYY-MM-DD");
      }
      doctor_fee
        .getConsultCostList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.over_time = item.over_time
                ? platform.timestampToTime(item.over_time)
                : "------";
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查看详情
    toDetail(consult_id) {
      this.$router.push({
        path: "wenzhendetail",
        query: {
          consult_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.title {
  font-size: 16px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .item {
    margin-right: 14px;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
}
</style>
